import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconFallback = (props) => (
  <Icon {...props} fill="none">
    <circle cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="2" />
    <path d="M14 4V24.5" stroke="currentColor" strokeWidth="2" />
  </Icon>
);
